export const locales = ["it", "en"] as const
export type Locale = (typeof locales)[number]
export const defaultLocale: Locale = "it"

// Italian is the default locale and will NOT have a prefix in URLs
// e.g., /about instead of /it/about
// Other locales WILL have a prefix
// e.g., /en/about, /fr/about

export function isValidLocale(locale: string): locale is Locale {
  return locales.includes(locale as Locale)
}

// Check if we need to include locale in URL
export function includeLocaleInUrl(locale: Locale): boolean {
  return locale !== defaultLocale
}
